<template>
<p :class="className">{{text}}</p>
</template>

<script>
export default {
  props: {
    text: String,
    className: String
  }
}
</script>

<style lang="scss" scoped>
.c-text {
  font-size: 1.6rem;
  line-height: 1.6;
  white-space: pre-wrap;
  &--bold {
    @extend .c-text;
    font-weight: 700;
  }
  &-ss {
    font-size: 1.2rem;
    &__error {
      @extend .c-text-ss;
      color: $color_red_orange;
    }
  }
  &-s {
    font-size: 1.4rem;
    &__bold {
      @extend .c-text-s;
      font-weight: 700;
    }
    &__error {
      @extend .c-text-s;
      margin-left: 1rem;
      color: $color_red_orange;
    }
  }
  &-xl {
    font-weight: 700;
    font-size: 32/1280*100vw;
    line-height: 1.2;
    @include media-queries-sp {
      font-size: 32/375*100vw;
    }
  }
  &-xxl {
    font-weight: 700;
    font-size: 40/1280*100vw;
    line-height: 1.2;
    @include media-queries-sp {
      font-size: 40/375*100vw;
    }
  }
}
</style>
